/* eslint-disable */
// import external dependencies
import 'jquery';
// Import everything from autoload
import './autoload/_bootstrap.js'


// import 'headroom.js/dist/jQuery.headroom';
// import Headroom from 'headroom.js/dist/headroom.min.js';
// var myElement = document.querySelector("header");
// var options = {
//   tolerance: 5,
//   offset: {
//       up: 50,
//       down: 50
//   },
// };
// var headroom  = new Headroom(myElement, options);
// headroom.init();


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import AOS from 'aos';
AOS.init();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});
// Load Events
jQuery(document).ready(() => routes.loadEvents());

// $('.your-class').slick({
//   autoplay: true,
//   autoplaySpeed: 5000,
// });

// $('.slider-track').slick({
//   autoplay: false,
//   autoplaySpeed: 5000,
// });

$("#button").click(function () {
  $('html').animate({ scrollTop: 0 }, 600)
});

$(window).scroll(function(e) { 
  if(100 < e.currentTarget.pageYOffset) {
    $(".navi").removeClass('not_show'); 
  } else {
    $(".navi").addClass('not_show'); 
  }
});
import Swiper from 'swiper/swiper-bundle.min.js';
// new Swiper('.slider-track', {
//   slidesPerView: 1,
//   loop: false,
//   navigation: {
//     nextEl: ".slider-track-next",
//     prevEl: ".slider-track-prev",
//   },
// });
// new Swiper('.slider-car', {
//   slidesPerView: 1,
//   loop: false,
//   grabCursor: true,
//   navigation: {
//     nextEl: ".slider-car-next",
//     prevEl: ".slider-car-prev",
//   },
// });



// new Swiper('.slider_top_newsticker', { // używam u samej góry!
//   slidesPerView: 1,
//   loop: true,
//   grabCursor: true,
//   navigation: {
//     nextEl: ".slider_top_newsticker-next",
//     prevEl: ".slider_top_newsticker-prev",
//   },
// });


// new Swiper('.last_posts', {
//   slidesPerView: 4,
//   loop: true,
//   spaceBetween: 20,
//   navigation: {
//     nextEl: ".last_posts-next",
//     prevEl: ".last_posts-prev",
//   },
//   breakpoints: {  
//   0: {       
//     slidesPerView: 2,       
//     spaceBetween: 10     
//  },
//   768: {       
//     slidesPerView: 3,       
//     spaceBetween: 20     
//   },
//   992: {       
//     slidesPerView: 4,      
//   } 
//   }

// });
new Swiper('.slider-track-cards', {
  slidesPerView: 4,
  grabCursor: true,
  loop: true,
  spaceBetween: 20,
  navigation: {
    nextEl: ".slider-track-next",
    prevEl: ".slider-track-prev",
  },
  breakpoints: {  
  0: {       
    slidesPerView: 2,       
    spaceBetween: 10     
 },
  768: {       
    slidesPerView: 3,       
    spaceBetween: 20     
  },
  992: {       
    slidesPerView: 4,      
  } 
  }

});


// new Swiper('.slider-home', {
//   slidesPerView: 1,
//   loop: false,
//   pagination: {
//     el: ".swiper-pagination",
//     dynamicBullets: true,
//   },
//   navigation: {
//     nextEl: ".slider-home-next",
//     prevEl: ".slider-home-prev",
//   },
// });

// var bestseller = new Swiper('.slider-offer', {
//   loop: false,
//   slidesPerView: 1,
//   pagination: {
//     el: '.swiper-pagination',
//   },
// });
// var slider_featured_set = new Swiper('.slider-featured-set', {
//   loop: false,
//   slidesPerView: 1,
//   pagination: {
//     el: '.swiper-pagination',
//   },
// });


// WEBPACK FOOTER //
// ./scripts/main.js